import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import { ActionButtonLayout } from '../../../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../../../v2BaseComponents/MainContentContainer';
import { ContentStack } from '../../../../../v2BaseComponents/Stack';
import Text from '../../../../../v2BaseComponents/Text';
import { useMedicalProfileDirectives } from '../../../../../../hooks/api/useMedicalProfileDirectives';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import CodeStatusSection from './CodeStatusSection';
import POASection from './POASection';

const intl = getIntl('AdvancedDirectives', {
    header: 'Advanced Directives: Empowering Your Wishes',
    subHeader:
        'Advanced directives are vital tools for ensuring your healthcare preferences are respected, especially during emergencies or at the end of life. By clearly defining your wishes—such as resuscitation preferences or a code status—you provide invaluable guidance to healthcare workers and peace of mind to your loved ones. These directives help prevent confusion during critical moments, ensuring that medical decisions align with your values and priorities. Take control of your care by outlining your preferences today.',
    editCodeStatus: 'Edit Code Status',
});

export type AdvancedDirectivesOwnProps = {
    profileId: string;
};

export type AdvancedDirectivesProps = AdvancedDirectivesOwnProps;

const AdvancedDirectives: React.FC<AdvancedDirectivesProps> = ({ profileId }) => {
    const { isLoadingPOA, isLoadingCodeStatus } = useMedicalProfileDirectives({
        medicalProfileId: profileId,
    });
    return (
        <AnimateLoadedContent isLoading={isLoadingPOA || isLoadingCodeStatus}>
            {() => (
                <ActionButtonLayout scrollable>
                    <MainContentContainer>
                        <ContentStack>
                            <Text variant="bold-h4">{intl('header')}</Text>
                            <Text variant="body-1">{intl('subHeader')}</Text>
                            <CodeStatusSection profileId={profileId} />
                            <POASection profileId={profileId} />
                        </ContentStack>
                    </MainContentContainer>
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AdvancedDirectives);
